import { Map, List, fromJS } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { createTableObj } from 'helpers/common'
import { createSiteGroupForm } from 'helpers/siteCroup'

// constants
export const FETCH_SITE_GROUP_LIST = 'siteGroup/FETCH_SITE_GROUP_LIST'
export const SUCCESS_SITE_GROUP_LIST = 'siteGroup/SUCCESS_SITE_GROUP_LIST'
export const FAILURE_SITE_GROUP_LIST = 'siteGroup/FAILURE_SITE_GROUP_LIST'
export const LOAD_SITE_GROUP_LIST = 'siteGroup/LOAD_SITE_GROUP_LIST'

export const FETCH_SITE_GROUP_TABLE = 'siteGroup/FETCH_SITE_GROUP_TABLE'
export const SUCCESS_SITE_GROUP_TABLE = 'siteGroup/SUCCESS_SITE_GROUP_TABLE'
export const FAILURE_SITE_GROUP_TABLE = 'siteGroup/FAILURE_SITE_GROUP_TABLE'
export const LOAD_SITE_GROUP_TABLE = 'siteGroup/LOAD_SITE_GROUP_TABLE'

export const FETCH_SITE_GROUP_FORM = 'siteGroup/FETCH_SITE_GROUP_FORM'
export const SUCCESS_SITE_GROUP_FORM = 'siteGroup/SUCCESS_SITE_GROUP_FORM'
export const FAILURE_SITE_GROUP_FORM = 'siteGroup/FAILURE_SITE_GROUP_FORM'
export const LOAD_SITE_GROUP_FORM = 'siteGroup/LOAD_SITE_GROUP_FORM'

export const SET_SITE_GROUP_INFO = 'siteGroup/SET_SITE_GROUP_INFO'
export const DELETE_SITE_GROUP_INFO = 'siteGroup/DELETE_SITE_GROUP_INFO'

export const CLEAR_SITE_GROUP_TABLE = 'siteGroup/CLEAR_SITE_GROUP_TABLE'
export const CLEAR_SITE_GROUP_FORM = 'siteGroup/CLEAR_SITE_GROUP_FORM'
export const CLEAR_SITE_GROUP_STORE = 'siteGroup/CLEAR_SITE_GROUP_STORE'

// actions
export const fetchSiteGroupList = ActionHelper.createActionObj(
  FETCH_SITE_GROUP_LIST,
)
export const fetchSiteGroupTable = ActionHelper.createActionObj(
  FETCH_SITE_GROUP_TABLE,
)
export const fetchSiteGroupForm = ActionHelper.createActionObj(
  FETCH_SITE_GROUP_FORM,
)
export const setSiteGroupInfo = ActionHelper.createActionObj(
  SET_SITE_GROUP_INFO,
)
export const deleteSiteGroupInfo = ActionHelper.createActionObj(
  DELETE_SITE_GROUP_INFO,
)
export const clearSiteGroupTable = ActionHelper.createActionObj(
  CLEAR_SITE_GROUP_TABLE,
)
export const clearSiteGroupForm = ActionHelper.createActionObj(
  CLEAR_SITE_GROUP_FORM,
)
export const clearSiteGroupStore = ActionHelper.createActionObj(
  CLEAR_SITE_GROUP_STORE,
)

// state
const initialState = () =>
  fromJS({
    isLoadList: false,
    isLoadTable: false,
    isLoadForm: false,
    siteGroupList: [],
    tableData: createTableObj(),
    formData: createSiteGroupForm(),
  })

// reducers
const siteGroup = handleActions(
  {
    [SUCCESS_SITE_GROUP_LIST]: (state, action) =>
      state.set('siteGroupList', List(action.payload)),
    [FAILURE_SITE_GROUP_LIST]: state => state.set('siteGroupList', List([])),
    [LOAD_SITE_GROUP_LIST]: (state, action) =>
      state.set('isLoadList', Boolean(action.payload)),

    [SUCCESS_SITE_GROUP_TABLE]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [combineActions(FAILURE_SITE_GROUP_TABLE, CLEAR_SITE_GROUP_TABLE)]: state =>
      state.set('tableData', Map(createTableObj())),
    [LOAD_SITE_GROUP_TABLE]: (state, action) =>
      state.set('isLoadTable', Boolean(action.payload)),

    [SUCCESS_SITE_GROUP_FORM]: (state, action) =>
      state.set('formData', Map(action.payload)),
    [combineActions(FAILURE_SITE_GROUP_FORM, CLEAR_SITE_GROUP_FORM)]: state =>
      state.set('formData', Map(createSiteGroupForm())),
    [LOAD_SITE_GROUP_FORM]: (state, action) =>
      state.set('isLoadForm', Boolean(action.payload)),

    [CLEAR_SITE_GROUP_STORE]: () => initialState(),
  },
  initialState(),
)

export default siteGroup
